import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowIcon from '@material-ui/icons/ArrowForward';
import React__default from 'react';
import { Link } from '../../components/Link/Link.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: "fit-content",
      padding: theme.spacing(2, 2, 2, 2.5)
    },
    boxTitle: {
      margin: 0,
      color: theme.palette.textSubtle
    },
    arrow: {
      color: theme.palette.textSubtle
    }
  }),
  { name: "BackstageBottomLink" }
);
function BottomLink(props) {
  const { link, title, onClick } = props;
  const classes = useStyles();
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Link, { to: link, onClick, underline: "none" }, /* @__PURE__ */ React__default.createElement(Box, { display: "flex", alignItems: "center", className: classes.root }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.boxTitle, fontWeight: "fontWeightBold", m: 1 }, /* @__PURE__ */ React__default.createElement(Typography, null, /* @__PURE__ */ React__default.createElement("strong", null, title))), /* @__PURE__ */ React__default.createElement(ArrowIcon, { className: classes.arrow }))));
}

export { BottomLink };
//# sourceMappingURL=BottomLink.esm.js.map
